import axios from 'axios';

const getAllAuth0Users = async (token, params) => {
  const { data } = await axios.post('/api/v1/auth0Api/search', params, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data.data;
};

const getUserByAuth0Id2 = async (token, auth0Id, withCenters = true) => {
  const { data } = await axios.get(`/api/v1/auth0Api/${auth0Id}`, {
    params: {
      iscenters: withCenters,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data.data;
};

const createUserAuth0 = async (token, body) => {
  const { data } = await axios.post('/api/v1/auth0Api', body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data.data;
};

const updateUserAuth0 = async (token, id, body) => {
  const { data } = await axios.patch(`/api/v1/auth0Api/${id}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data.data;
};

const blockUserAuth0 = async (token, id) => {
  const { data } = await axios.patch(
    `/api/v1/auth0Api/${id}/status`,
    {
      status: 'inactive',
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return data.data;
};

const unBlockUserAuth0 = async (token, id) => {
  const { data } = await axios.patch(
    `/api/v1/auth0Api/${id}/status`,
    {
      status: 'active',
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return data.data;
};

const resetUserPasswordAuth0 = async (token, id) => {
  const { data } = await axios.patch(
    `/api/v1/auth0Api/${id}/reset-password`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return data.data;
};

export {
  getAllAuth0Users,
  getUserByAuth0Id2,
  createUserAuth0,
  updateUserAuth0,
  blockUserAuth0,
  unBlockUserAuth0,
  resetUserPasswordAuth0,
};
